module.exports = __webpack_public_path__ + "img/a4c21f7eb01fc4130b02451c1961d196.a8929622.png";